import { render, staticRenderFns } from "./LocalizeItemForm.vue?vue&type=template&id=3e7a9e11&scoped=true&"
import script from "./LocalizeItemForm.vue?vue&type=script&lang=js&"
export * from "./LocalizeItemForm.vue?vue&type=script&lang=js&"
import style0 from "./LocalizeItemForm.vue?vue&type=style&index=0&id=3e7a9e11&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e7a9e11",
  null
  
)

export default component.exports